import React, { FunctionComponent, useMemo } from 'react';

import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme/ScopedTheme';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { selectConferenceBackground } from '../../../../../shared/features/config/selectors';
import { ParticipantsSidebar } from '../../../components/participants-sidebar';
import { ConferenceStatus } from '../../../constants';
import { getConferenceStatus, getSidebarContent } from '../../../selectors';
import { SidebarContent } from '../../../types';
import { ChatWidget } from '../../chat';
import styles from './styles.css';

interface SidebarProps {
    withChat?: boolean;
}

const Sidebar: FunctionComponent<SidebarProps> = ({ withChat }) => {
    const sidebarContent = useSelector(getSidebarContent);
    const isJoined = useSelector((state) => getConferenceStatus(state) === ConferenceStatus.JOINED);
    const isVisible = useMemo(() => sidebarContent !== null && isJoined, [sidebarContent, isJoined]);

    const conferenceBackground = useSelector(selectConferenceBackground);

    return (
        <ScopedTheme theme="dark">
            <div
                className={cn(styles.sidebar, { [styles.visible]: isVisible })}
                style={conferenceBackground ? { backgroundColor: conferenceBackground } : {}}
            >
                {withChat ? <ChatWidget visible={sidebarContent === SidebarContent.Chat} /> : null}
                {sidebarContent === SidebarContent.Participants ? <ParticipantsSidebar /> : null}
            </div>
        </ScopedTheme>
    );
};

export { Sidebar };
